;
(function (ng) {
  'use strict';

  angular.module('mouseoverClassToggler', []);
})(window.angular);